import PropTypes from 'prop-types';
import { useState } from 'react';
// material-ui
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import useMediaQuery from '@mui/material/useMediaQuery';

// project import
import NavItem from './NavItem';
import { useGetMenuMaster, handlerDrawerOpen } from 'api/menu';

// ==============================|| NAVIGATION - COLLAPSE ||============================== //

function NavCollapse({ item, level }) {
  const [open, setOpen] = useState(false);
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const handleClick = () => {
    // Se o menu está fechado, abre primeiro
    if (!drawerOpen) {
      handlerDrawerOpen(true);
      // Aguarda um pouco pro menu abrir, depois expande o collapse
      setTimeout(() => setOpen(true), 200);
    } else {
      // Menu já está aberto, só alterna o collapse
      setOpen(!open);
    }
  };

  const Icon = item.icon;
  const itemIcon = item.icon ? <Icon style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} /> : false;

  const textColor = 'text.primary';
  const iconSelectedColor = 'primary.main';

  return (
    <>
      <ListItemButton
        onClick={handleClick}
        sx={{
          zIndex: 1201,
          pl: drawerOpen ? `${level * 28}px` : 1.5,
          py: !drawerOpen && level === 1 ? 1.25 : 1,
          ...(drawerOpen && {
            '&:hover': { bgcolor: 'primary.lighter' }
          }),
          ...(!drawerOpen && {
            '&:hover': { bgcolor: 'transparent' }
          })
        }}
      >
        {itemIcon && (
          <ListItemIcon
            sx={{
              minWidth: 28,
              color: open ? iconSelectedColor : textColor,
              ...(!drawerOpen && {
                borderRadius: 1.5,
                width: 36,
                height: 36,
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': { bgcolor: 'secondary.lighter' }
              }),
              ...(!drawerOpen && open && {
                bgcolor: 'primary.lighter',
                '&:hover': { bgcolor: 'primary.lighter' }
              })
            }}
          >
            {itemIcon}
          </ListItemIcon>
        )}
        {/* ✅ SÓ MOSTRA TEXTO SE MENU ESTIVER ABERTO */}
        {drawerOpen && (
          <ListItemText
            primary={
              <Typography variant="h6" sx={{ color: open ? iconSelectedColor : textColor }}>
                {item.title}
              </Typography>
            }
          />
        )}
      </ListItemButton>
      {/* ✅ SÓ RENDERIZA COLLAPSE SE MENU ESTIVER ABERTO */}
      {drawerOpen && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children?.map((menuItem) => (
              <NavItem key={menuItem.id} item={menuItem} level={level + 1} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}

NavCollapse.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number
};

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

export default function NavGroup({ item }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return <NavCollapse key={menuItem.id} item={menuItem} level={1} />;
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color="textSecondary">
              {item.title}
            </Typography>
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
}

NavGroup.propTypes = { item: PropTypes.object };